import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import NoBaseStage, { NoBaseStageParameters } from '../stages/filters/NoBaseStage';

export type NoBaseParameters = BlockParameters & NoBaseStageParameters & {};

@AddMetadata({
    type: BlockKeys.NoBase,
    name: 'No Overhang',
    description:
        'Removes all floating Sensor Points starting from the first level going upwards. The positions of Sensor Points at lower levels is therefore influencing the presence of Sensor Points at higher levels',
})
class NoBaseBlock extends PipelineBlock<NoBaseParameters> {
    constructor(params: NoBaseParameters, id?: string) {
        super(params, id);
    }

    protected override defineStages() {
        return [new NoBaseStage()];
    }
}

export default NoBaseBlock;
